import { SubscriptionType } from '@/types/subscription'

/** Locale values accepted by the Stripe billing portal API */
export const BILLING_PORTAL_LOCALE = {
  AUTO: 'auto',
  EN: 'en',
  FR: 'fr',
} as const

/**
 * Stripe interval values (different from SubscriptionInterval which uses 'monthly'/'yearly')
 */
export const STRIPE_INTERVAL = {
  MONTH: 'month',
  YEAR: 'year',
} as const

export type StripeInterval = (typeof STRIPE_INTERVAL)[keyof typeof STRIPE_INTERVAL]

/**
 * Stripe metadata type values for subscription offers
 */
export const STRIPE_METADATA_TYPE = {
  INTERN: 'interne',
  MEDECIN: 'médecin',
  MEDECIN_ALT: 'medecin',
  ADHERENT: 'adhérent',
  ADHERENT_ALT: 'adherent',
} as const

export const SUBSCRIPTION_PLANS = [
  {
    id: SubscriptionType.INDIVIDUAL,
    titleKey: 'subscription.plans.individual.title',
    descriptionKey: 'subscription.plans.individual.description',
  },
  {
    id: SubscriptionType.STRUCTURE,
    titleKey: 'subscription.plans.structure.title',
    descriptionKey: 'subscription.plans.structure.description',
    pricingNote: {
      labelKey: 'subscription.plans.structure.pricingNote.label',
      valueKey: 'subscription.plans.structure.pricingNote.value',
    },
  },
] as const
